import { ruleSetSingleWallHingedOrOpen } from './RuleSetSingleWallHingedOrOpen';
import { ruleSetSingleWallSliding } from './RuleSetSingleWallSlidning';

/**
 * Returns list of frames matching input width. Returns rule set that is equal or lower
 * than input width.
 * @param width The width of a shape or wall.
 * @param slidingDoors If true use the sliding doors rule set. Otherwise use hinged doors.
 * @returns list of frame widths that together are less or equal to input width
 */
export const getSingleWallRuleSet = (width: number, slidingDoors?: boolean): number[] => {
  const key = findMatchingRuleSet(
    width,
    slidingDoors ? ruleSetSingleWallSliding : ruleSetSingleWallHingedOrOpen
  );

  return slidingDoors ? ruleSetSingleWallSliding[key] : ruleSetSingleWallHingedOrOpen[key];
};

const findMatchingRuleSet = (width: number, ruleSet: AutofillSingleWallRules): number => {
  let matchingKey = 0;
  Object.keys(ruleSet).forEach(key => {
    const keyAsNumber = Number(key);
    if (keyAsNumber <= width) {
      matchingKey = keyAsNumber;
    }
  });

  return matchingKey;
};

export interface AutofillSingleWallRules {
  [key: number]: number[];
}

export const getAllAvailableHingedWidths = () => {
  return Object.keys(ruleSetSingleWallHingedOrOpen).filter(key => {
    const keyAsNumber = Number(key);
    return ruleSetSingleWallHingedOrOpen[keyAsNumber].length > 0;
  });
};

export const getAllAvailableSlidingWidths = () => {
  return Object.keys(ruleSetSingleWallSliding).filter(key => {
    const keyAsNumber = Number(key);
    return ruleSetSingleWallSliding[keyAsNumber].length > 0;
  });
};
